export default {
  'EMAILSTATUSTEMPLATE' (state) {
    return state.statusTemplate
  },
  'EMAILSTATUSTEMPLATES' (state) {
    return state.statusTemplates
  }
}
